module.exports = __webpack_public_path__ + "static/media/woman-in-office@2x.df23e536.png";